import React from "react";
import { useSelector } from "react-redux";
import GoogleChart, { commonOptions } from "../../../../components/charts/googleChart/googleChart";
import NoData from "../../../../components/noData/noData";

const FreezeLifecyclePieChart = () => {
  const pieCharts = useSelector((state) => state.freezeLifecycle.chartsData.pie_charts);

  if (!pieCharts) return null;

  return pieCharts.map(({ data_table: { cols, rows }, options }, index) => (
    <div key={index} className="pie-chart">
      {rows.length ? (
        <GoogleChart
          width={540}
          height={300}
          chartType="PieChart"
          columns={cols}
          rows={rows}
          options={{
            ...commonOptions,
            ...options,
            chartArea: { left: 0, width: "100%", height: "80%", bottom: 10 }
          }}
          showCurrency={false}
          showAdditionTooltip={false}
          showXLSX={false}
        />
      ) : (
        <NoData />
      )}
    </div>
  ));
};

export default FreezeLifecyclePieChart;
